<template>
  <div :id="id" :class="className" :style="{height:height,width:width}"/>
</template>

<script>
import echarts from 'echarts'
import resize from './mixins/resize'
import moment from 'moment-timezone'
import { buildAppWebUrl } from '@/utils/appWebUrl'

import '../../../node_modules/echarts/map/js/china.js' // 引入中国地图数据

import '../../../node_modules/echarts/map/js/province/anhui.js'
import '../../../node_modules/echarts/map/js/province/aomen.js'
import '../../../node_modules/echarts/map/js/province/beijing.js'
import '../../../node_modules/echarts/map/js/province/chongqing.js'
import '../../../node_modules/echarts/map/js/province/fujian.js'
import '../../../node_modules/echarts/map/js/province/gansu.js'
import '../../../node_modules/echarts/map/js/province/guangdong.js'
import '../../../node_modules/echarts/map/js/province/guangxi.js'
import '../../../node_modules/echarts/map/js/province/guizhou.js'
import '../../../node_modules/echarts/map/js/province/hainan.js'
import '../../../node_modules/echarts/map/js/province/hebei.js'
import '../../../node_modules/echarts/map/js/province/heilongjiang.js'
import '../../../node_modules/echarts/map/js/province/henan.js'
import '../../../node_modules/echarts/map/js/province/hubei.js'
import '../../../node_modules/echarts/map/js/province/hunan.js'
import '../../../node_modules/echarts/map/js/province/jiangsu.js'
import '../../../node_modules/echarts/map/js/province/jiangxi.js'
import '../../../node_modules/echarts/map/js/province/jilin.js'
import '../../../node_modules/echarts/map/js/province/liaoning.js'
import '../../../node_modules/echarts/map/js/province/neimenggu.js'
import '../../../node_modules/echarts/map/js/province/ningxia.js'
import '../../../node_modules/echarts/map/js/province/qinghai.js'
import '../../../node_modules/echarts/map/js/province/shandong.js'
import '../../../node_modules/echarts/map/js/province/shanghai.js'
import '../../../node_modules/echarts/map/js/province/shanxi.js'
import '../../../node_modules/echarts/map/js/province/shanxi1.js'
import '../../../node_modules/echarts/map/js/province/sichuan.js'
import '../../../node_modules/echarts/map/js/province/taiwan.js'
import '../../../node_modules/echarts/map/js/province/tianjin.js'
import '../../../node_modules/echarts/map/js/province/xianggang.js'
import '../../../node_modules/echarts/map/js/province/xinjiang.js'
import '../../../node_modules/echarts/map/js/province/xizang.js'
import '../../../node_modules/echarts/map/js/province/yunnan.js'
import '../../../node_modules/echarts/map/js/province/zhejiang.js'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '200px'
    },
    height: {
      type: String,
      default: '200px'
    }, path: {
      type: String
    }, pre_path: {
      type: String

    }, base_path: {
      type: String
    }, place: {
      type: String,
      default: "china"
    }, params: {}
  },
  data() {
    return {
      chart: null,
      polling: null
    }
  },
  mounted() {
    this.initChart(this.place, this.path, this.params);
  },
  created: function () {
    this.pullData()
  },
  beforeDestroy() {
    clearInterval(this.polling)
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  watch: {
    '$route': function (to, from) {
      if (to != from) {
        this.initChart(this.place, this.path, this.params);
      }
    }
  },
  methods: {
    pullData() {
      var self = this
      this.polling = setInterval(() => {
        self.initChart(self.place, self.path, this.params);
      }, 60000)
    },
    // pullData2(place,path) {
    //   var self = this
    //   this.polling = setInterval(() => {
    //     self.initChart(place, path,);
    //   }, 60000)
    // },
    // 计算开始时间：结束时间减去365天
    calculateStartDate(endDate) {
      // 将结束时间字符串转换为 moment 对象
      const endMoment = moment(endDate, 'YYYY-MM-DD HH:mm:ss')
      // 减去365天，并设置为当天的开始时间（00:00:00）
      const startMoment = endMoment.clone().subtract(365, 'days').startOf('day')
      // 返回格式化后的开始时间字符串
      return startMoment.format('YYYY-MM-DD HH:mm:ss')
    },
    initChart(place, path, params) {
      params = {"date_start": params["date_start"], "date_end": params["date_end"],}
      params.date_start = this.calculateStartDate(params.date_end)
      // 使用示例：params.date_start = this.calculateStartDate("2021-12-12 23:59:59") 
      const urlParams = new URL("http://127.0.0.1/" + path).searchParams;
      for (const entry of urlParams.entries()) {
        params[entry[0]] = entry[1]
      }

      this.chart = echarts.init(document.getElementById(this.id), 'dark')

      this.chart.setOption({ // 进行相关配置
        backgroundColor: "#080A20",
        toolbox: {
          show: true,
          feature: {
            myTool1: {
              show: true,
              title: '全屏开关',
              // id:"mydicttool1",
              icon: "path://M1.5 1a.5.5 0 0 0-.5.5v4a.5.5 0 0 1-1 0v-4A1.5 1.5 0 0 1 1.5 0h4a.5.5 0 0 1 0 1h-4zM10 .5a.5.5 0 0 1 .5-.5h4A1.5 1.5 0 0 1 16 1.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 0-.5-.5h-4a.5.5 0 0 1-.5-.5zM.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 0 14.5v-4a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a.5.5 0 0 1 0-1h4a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 1 .5-.5z",
              onclick: () => {
                const element = document.getElementById(this.id);
                // ="ddd"
                //  alert( self.title)
                if (element.requestFullScreen) { // HTML W3C 提议
                  element.requestFullScreen();
                } else if (element.msRequestFullscreen) { // IE11
                  element.msRequestFullScreen();
                } else if (element.webkitRequestFullScreen) { // Webkit (works in Safari5.1 and Chrome 15)
                  element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) { // Firefox (works in nightly)
                  element.mozRequestFullScreen();
                }
                // 退出全屏
                if (element.requestFullScreen) {
                  document.exitFullscreen();
                } else if (element.msRequestFullScreen) {
                  document.msExitFullscreen();
                } else if (element.webkitRequestFullScreen) {
                  document.webkitCancelFullScreen();
                } else if (element.mozRequestFullScreen) {
                  document.mozCancelFullScreen();
                }
              },
            }
          }
        },
        dataRange: {
          show: true,
          // min: 0,
          // max: 30,
          text: ['High', 'Low'],
          realtime: true,
          calculable: true,
          color: ["#5470c6", "#91cc75",
            "#fac858", "#ee6666",
            "#73c0de", "#3ba272",
            "#fc8452", "#9a60b4", "#ea7ccc"]
          // color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026']
          // color: ["#226D41", "#CEF1DE",]
        },

        geo: { // 这个是重点配置区
          map: place, // 表示中国地图
          roam: true,
          label: {
            emphasis: {
              show: true
            }, normal: {
              show: true
            }
          },
        },
        series: [{
          type: 'scatter',
          coordinateSystem: 'geo' // 对应上方配置
        },
          {
            name: '启动次数', // 浮动框的标题
            type: 'map',
            geoIndex: 0,
            data: []
          }
        ]
      })


      this.$http.post(process.env.VUE_APP_API_HOST + "/" + path, params).then((res) => {
        if (path == "clinic_total_fees") {
          this.chart.on("click", (param) => {
            if (param.componentType === 'markPoint') {
              console.log('markPoint clicked')
              window.open(buildAppWebUrl("/clinic?doctor_id=-1&clinic_id=" + param.data.id), '_blank', 'noopener,noreferrer');
            } else {
              this.pre_path = path;
              this.base_path = path;
              this.place = param.name
              clearInterval(this.polling)
              this.chart.dispose();
              this.path = "show_province_detail_fees?province=" + param.name;
              this.initChart(param.name, this.path, params);
            }
          })
        }
        if (path == "clinic_china_map") {
          this.chart.on("click", (param) => {
            if (param.componentType === 'markPoint') {
              console.log('markPoint clicked')
              window.open(buildAppWebUrl("/clinic?doctor_id=-1&clinic_id=" + param.data.id), '_blank', 'noopener,noreferrer');
            } else {
              this.pre_path = path;
              this.base_path = path;
              this.place = param.name;
              clearInterval(this.polling)
              this.chart.dispose();
              this.path = "show_province_detail?province=" + param.name;
              this.initChart(param.name, this.path, params);
            }
          })
        }
        if (path == "clinic_kfsl") {
          this.chart.on("click", (param) => {
            // console.log(param.componentType)
            if (param.seriesType === 'effectScatter') {
              console.log('markPoint clicked')
              window.open(buildAppWebUrl("/clinic?doctor_id=-1&clinic_id=" + param.data.id), '_blank', 'noopener,noreferrer');
            } else {

              // 对于pop不再允许点击
              if (param.name.indexOf("处方量") != -1) {
                return;
              }
              // console.log('click stop1:' + param.name);
              // console.log('this.path:' + this.path);
              this.pre_path = path;
              this.base_path = path;
              this.place = param.name;
              clearInterval(this.polling)
              this.chart.dispose();
              this.path = "show_province_detail_kfsl?province=" + param.name;
              this.initChart(param.name, this.path, params);
              // this.pullData2(param.name, this.path);
            }
          })
        }
        if (path.indexOf("cityName") == -1 && (path.indexOf("show_province_detail") != -1
            || path.indexOf("show_province_detail_fees") != -1
            || path.indexOf("show_province_detail_kfsl") != -1)) {
          this.chart.on("click", (param) => {

            if (param.componentType === 'markPoint') {
              console.log('markPoint clicked')
              window.open(buildAppWebUrl("/clinic?doctor_id=-1&clinic_id=" + param.data.id), '_blank', 'noopener,noreferrer');
            } else {
              this.$http.get(process.env.VUE_APP_API_HOST + "/get_map_json_data?name=" + param.name).then((res) => {
                if (res.data.data == "-1") {
                  clearInterval(this.polling)
                  this.chart.dispose();
                  this.path = this.base_path;
                  this.place = 'china'
                  this.initChart("china", this.path, params);
                  // this.pullData2('china', this.path);
                  return
                }
                clearInterval(this.polling)
                this.chart.dispose();
                this.pre_path = path;
                this.path = path + "&cityName=" + param.name
                this.place = param.name;
                this.chart.dispose();
                echarts.registerMap(param.name, res.data.data);
                this.initChart(param.name, this.path, params);
                // this.pullData2(param.name, this.path);
              })
            }
          })
        }
        if (path.indexOf("cityName") != -1) {
          this.chart.on("click", (param) => {
            if (param.componentType === 'markPoint') {
              console.log('markPoint clicked')
              window.open(buildAppWebUrl("/clinic?doctor_id=-1&clinic_id=" + param.data.id), '_blank', 'noopener,noreferrer');
            } else {
              clearInterval(this.polling)
              this.chart.dispose();
              // this.path = this.pre_path;
              this.path = this.base_path
              // this.initChart(this.path.split("?")[1].split("&")[0].split("=")[1]);
              this.place = "china";
              this.initChart("china", this.path, params);
            }
          })
        }

        let options = {
          dataRange: {
            show: true,
            min: res.data.min,
            max: res.data.max,
            text: ['高', '低'],
            realtime: false,
            calculable: true,
            color: ["#5470c6", "#91cc75",
              "#fac858", "#ee6666",
              "#73c0de", "#3ba272",
              "#fc8452", "#9a60b4", "#ea7ccc"]
            // color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026']
          },
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              var res1 = params.name + '<br/>';
              var myseries = res.data.data;
              for (var i = 1; i < myseries.length; i++) {
                try {
                  for (var j = 0; j < myseries[i].data.length; j++) {
                    if (myseries[i].data[j].name == params.name) {
                      //skip coordiate system to show
                      if (!Array.isArray(myseries[i].data[j].value)) {
                        if (Array.isArray(myseries[i].name)) {
                          res1 += myseries[i].name[0] + ':' + myseries[i].data[j].value + '<br>'
                              + myseries[i].name[1] + ':' + myseries[i].data[j].value1 + '<br>';
                        } else {
                          res1 += myseries[i].name + ':' + myseries[i].data[j].value + '</br>';
                        }
                      }

                    }
                  }
                } catch (error) {
                  console.log(error);
                }
              }
              return res1;
            }
          }, // 鼠标移到图里面的浮动提示框
          click: {},
          series: res.data.data,
          //https://www.w3cschool.cn/echarts_tutorial/echarts_tutorial-3nwi2cdn.html
          title: {
            backgroundColor: "#044C6A",
            left: "center",
            subtext: res.data.title_subtext,
            subtextStyle: {
              fontSize: 14,
              rich: {
                yellow: {
                  fontSize: 13,
                  color: '#F6F9FA',
                  align: 'center',
                  padding: [3, 3, 3, 3],
                  width: 105
                },
                blue: {
                  fontSize: 20,
                  fontWeight: 600,
                  align: 'center',
                  color: '#25F3E6',
                  padding: [3, 3, 3, 3],
                  width: 105
                }
              }
            }
          },
        }
        this.chart.setOption(options)
      })
    }
  }
}
</script>
